import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { ConversationWithStudent } from '@/lib/types';

export function totalUnreadFromConversations(
  conversations: { unread_personal: number }[]
): number {
  return conversations.reduce((sum, c) => sum + c.unread_personal, 0);
}

export function useConversations(personalId: string): {
  conversations: ConversationWithStudent[];
  totalUnread: number;
  isLoading: boolean;
  error: Error | null;
} {
  const { data = [], isLoading, error } = useQuery({
    queryKey: ['conversations', personalId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('conversations')
        .select('*, student:profiles!student_id(full_name)')
        .eq('personal_id', personalId)
        .order('last_message_at', { ascending: false, nullsFirst: false });
      if (error) throw error;
      return data as ConversationWithStudent[];
    },
    staleTime: 0, // refetch on every mount — badge must show fresh count without Realtime
    enabled: !!personalId,
  });

  return {
    conversations: data,
    totalUnread: totalUnreadFromConversations(data),
    isLoading,
    error: error as Error | null,
  };
}
